import React, { useState } from 'react';
import {
  Button,
  Col,
  Descriptions,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  notification, Popconfirm,
  Radio,
  Row,
  Select,
} from 'antd';
import { CustomSelector } from '../index';
import { CopyOutlined, WarningOutlined } from '@ant-design/icons';
import {
  deactivateForm,
  deleteForm,
  getCategories,
  getFormsByProject,
  getProjectsByStatus,
} from '../../api/module/forms';
import MESSAGES from '../../enums/Messages';
import { catchException } from '../../utils/helpers/helpers';

const { TextArea } = Input;
const projectStatus = 1;

const ModalForm = ({
  onCancel,
  onFinish,
  onFinishFailed,
  loading,
  data,
  cloneData,
  isEditing,
  isClone,
  setReloadForms,
}) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    const requestData = {
      ...values,
      id: data?.id,
    };
    onFinish(requestData);
  };

  return (
    <>
      {isClone && cloneData && (
        <Descriptions bordered style={{ marginBottom: '10px' }}>
          <Descriptions.Item label="Código" span={1}>
            {cloneData?.codigo}
          </Descriptions.Item>
          <Descriptions.Item label="Formulario a clonar" span={1}>
            {cloneData?.nombre}
          </Descriptions.Item>
          <Descriptions.Item label="Proyecto" span={1}>
            {cloneData?.proyecto_nombre}
          </Descriptions.Item>
        </Descriptions>
      )}
      <Form
        form={form}
        layout="vertical"
        name="basic"
        onFinish={handleFinish}
        onFinishFailed={onFinishFailed}
        initialValues={data}
        preserve={false}
      >
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              label="Código"
              name="codigo"
              rules={[
                { required: true, message: 'Por favor ingrese un código' },
                {
                  min: 3,
                  message: 'El código debe tener al menos 3 caracteres',
                },
                {
                  max: 10,
                  message: 'El código no puede tener más de 10 caracteres',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item
              label="Nombre Formulario"
              name="nombre"
              rules={[
                {
                  required: true,
                  message: 'Por favor ingrese un nombre de formulario',
                },
                {
                  max: 100,
                  message:
                    'El nombre del formulario no puede tener más de 100 caracteres',
                },
              ]}
            >
              <TextArea
                rows={1}
                showCount
                maxLength={100}
                autoSize={{ minRows: 1, maxRows: 1 }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          label="Descripción"
          name="descripcion"
          rules={[
            { required: true, message: 'Por favor ingrese una descripción' },
            {
              max: 250,
              message: 'La descripción no puede tener más de 250 caracteres',
            },
          ]}
        >
          <TextArea
            rows={2}
            showCount
            maxLength={250}
            autoSize={{ minRows: 2, maxRows: 4 }}
          />
        </Form.Item>
        <Form.Item
          label="Texto Link de Acceso"
          name="texto_enlace"
          rules={[
            {
              required: true,
              message: 'Por favor ingrese un texto para el link de acceso',
            },
            {
              max: 20,
              message:
                'El texto del link de acceso no puede tener más de 20 caracteres',
            },
          ]}
        >
          <TextArea
            rows={1}
            showCount
            maxLength={20}
            autoSize={{ minRows: 1, maxRows: 1 }}
          />
        </Form.Item>
        <Row>
          <Col span={24}>
            <Form.Item
              label="Proyecto"
              name="proyecto"
              rules={[
                { required: true, message: 'Por favor seleccione un proyecto' },
              ]}
              valuePropName="initialValue"
            >
              <CustomSelector
                selectorProps={{
                  style: { width: '100%' },
                  placeholder: 'Proyectos',
                }}
                endpointFetch={async () => {
                  return await getProjectsByStatus(projectStatus);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ marginTop: '20px' }} gutter={16}>
          <Col span={18}>
            <Form.Item
              label="Categoría"
              name="categoria"
              rules={[
                {
                  required: true,
                  message: 'Por favor seleccione una categoría',
                },
              ]}
              valuePropName="initialValue"
            >
              <CustomSelector
                selectorProps={{
                  style: { width: '100%' },
                  placeholder: 'Categorías',
                }}
                endpointFetch={async () => {
                  return await getCategories();
                }}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Estado Formulario"
              name="estado"
              rules={[
                { required: true, message: 'Por favor seleccione un estado' },
              ]}
            >
              <Select>
                <Select.Option value={true}>Activo</Select.Option>
                <Select.Option value={false}>Inactivo</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item noStyle dependencies={['proyecto']}>
              {({ getFieldValue }) => {
                const p = getFieldValue('proyecto');

                return (
                  <Form.Item
                    label="Formulario Padre:"
                    name="formulario_padre"
                    valuePropName="initialValue"
                  >
                    <CustomSelector
                      selectorProps={{
                        style: { width: '100%' },
                        placeholder: 'Asignados a este proyecto',
                      }}
                      disabled={!p}
                      endpointFetch={async () => {
                        if (!p) return { data: { results: [] } };
                        return await getFormsByProject(p, data?.id);
                      }}
                      key={`s_proyecto_${p}`}
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} style={{ marginTop: '20px' }}>
          <Col span={4}>
            <Form.Item
              label="Múltiple"
              name="multiple"
              rules={[{ required: true }]}
            >
              <Radio.Group>
                <Radio value={true}>Sí</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Orden en la Unidad"
              name="orden_unidad"
              rules={[
                {
                  required: true,
                  message: 'Por favor ingrese el orden en la unidad',
                },
              ]}
              tooltip={{
                title:
                  'Orden en el cual se le muestran los formularios al usuario al ingresar a la ventana de la unidad',
              }}
            >
              <InputNumber />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Icono Estado" name="icono_estado">
              <Radio.Group>
                <Radio value={true}>Sí</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Formulario Público" name="formulario_publico">
              <Radio.Group>
                <Radio value={true}>Sí</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Evidencias" name="evidencia">
              <Radio.Group>
                <Radio value={true}>Sí</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Form.Item noStyle dependencies={['formulario_publico']}>
            {({ getFieldValue }) =>
              getFieldValue('formulario_publico') &&
              isEditing && (
                <Col span={4}>
                  <Form.Item label="URL Creada">
                    <Input
                      value={`${process.env.REACT_APP_HOST}/polls/${data.codigo}`}
                      disabled
                      addonAfter={
                        <CopyOutlined
                          onClick={() => {
                            navigator.clipboard.writeText(
                              `${process.env.REACT_APP_HOST}/polls/${data.codigo}`,
                            );
                            message.success('URL copiada al portapapeles');
                          }}
                        />
                      }
                    />
                  </Form.Item>
                </Col>
              )
            }
          </Form.Item>
        </Row>
        <Form.Item>
          <Button
            type="primary"
            htmlType="button"
            loading={loading}
            onClick={() => { form.submit(); }}
          >Guardar</Button>
          <Button
            danger
            style={{ marginLeft: '10px' }}
            onClick={onCancel}
          >Cerrar</Button>
          {isEditing && (
            <div style={{ float: 'right' }}>
              <Popconfirm
                title="Desactivar Formulario"
                description='Está seguro de desactivar el formulario ?'
                onConfirm={async () => {
                  try {
                    await deactivateForm(data.id);
                    notification.success({
                      message: MESSAGES.SUCCESS_MSG,
                      description: MESSAGES.DESC_SUCCESS_MSG,
                      duration: 2,
                    });
                    setReloadForms({});
                    onCancel();
                  } catch (error) {
                    catchException(error);
                  }
                }}
                icon={<WarningOutlined style={{ color: 'red' }} />}
              >
                <Button
                  danger
                  htmlType="button"
                  loading={loading}
                  style={{ marginLeft: '10px' }}
                >Desactivar</Button>
              </Popconfirm>
              <Popconfirm
                title="Eliminar Formulario"
                description='Está seguro de eliminar el formulario ?'
                onConfirm={async () => {
                  try {
                    await deleteForm(data.id);
                    notification.success({
                      message: MESSAGES.SUCCESS_MSG,
                      description: MESSAGES.DESC_SUCCESS_MSG,
                      duration: 2,
                    });
                    setReloadForms({});
                    onCancel();
                  } catch (error) {
                    catchException(error, "No se puede eliminar el formulario, porque tiene datos asociados.");
                  }
                }}
                icon={<WarningOutlined style={{ color: 'red' }} />}
              >
                <Button
                  danger
                  htmlType="button"
                  loading={loading}
                  style={{ marginLeft: '10px' }}
                >Eliminar</Button>
              </Popconfirm>
            </div>
          )}
        </Form.Item>
      </Form>
    </>
  );
};

export default ModalForm;
